export enum MediaType {
    // eslint-disable-next-line no-unused-vars
    photo = 'PHOTO',
    // eslint-disable-next-line no-unused-vars
    video = 'VIDEO',
    // eslint-disable-next-line no-unused-vars
    undefined = 'TYPE_UNSPECIFIED'
}

export enum VideoProcessingStatus {
    // eslint-disable-next-line no-unused-vars
    UNSPECIFIED = 'UNSPECIFIED',
    // eslint-disable-next-line no-unused-vars
    PROCESSING = 'PROCESSING',
    // eslint-disable-next-line no-unused-vars
    READY = 'READY',
    // eslint-disable-next-line no-unused-vars
    FAILED = 'FAILED'
}
export interface MediaItem {
    id: string
    createTime: string
    type: MediaType
    mediaFile: GooglePhotosTypes
    imageBlobThumbnail: string
    imageBlobThumbnailReqested: boolean
}

export interface GooglePhotosTypes {
    baseUrl: string
    mimeType: string
    filename: string
    mediaFileMetadata: MediaFileMetadata
}

export interface MediaFileMetadata {
    width: bigint
    height: bigint
    cameraMake: string
    cameraModel: string

    // Union field metadata can be only one of the following:
    photoMetadata?: PhotoMetadata
    videoMetadata?: VideoMetadata
}

export interface PhotoMetadata {
    focalLength: number
    apertureFNumber: number
    isoEquivalent: bigint
    exposureTime: string
}

export interface VideoMetadata {
    fps: number
    processingStatus: VideoProcessingStatus
}